import { render, staticRenderFns } from "./SupplierBaseData.vue?vue&type=template&id=4d8a5c20"
import script from "./SupplierBaseData.vue?vue&type=script&lang=js"
export * from "./SupplierBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports